import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Persisted settings for the full-screen critical-alarm overlay (AlarmCenter).
 *
 * Kept separate from the voice (`useTtsStore`) settings: voice on/off is a
 * global control-room concern surfaced in the TopBar/NOC, whereas these govern
 * the PWA push-alarm UX (full-screen card, vibration, OS notification).
 */

export type AlarmThreshold = 2 | 3; // 2 = 경계+, 3 = 심각 only

interface AlarmSettings {
  /** Show the full-screen alarm card on a new qualifying alert. */
  overlayEnabled: boolean;
  setOverlayEnabled: (v: boolean) => void;
  /** Buzz the device (navigator.vibrate) when the card appears. */
  vibrate: boolean;
  setVibrate: (v: boolean) => void;
  /** Also raise an OS-level Notification when the tab is hidden. */
  notifyBrowser: boolean;
  setNotifyBrowser: (v: boolean) => void;
  /** Minimum level that triggers the full-screen card. */
  threshold: AlarmThreshold;
  setThreshold: (v: AlarmThreshold) => void;
}

export const useAlarmSettings = create<AlarmSettings>()(
  persist(
    (set) => ({
      overlayEnabled: true,
      setOverlayEnabled: (overlayEnabled) => set({ overlayEnabled }),
      vibrate: true,
      setVibrate: (vibrate) => set({ vibrate }),
      notifyBrowser: false,
      setNotifyBrowser: (notifyBrowser) => set({ notifyBrowser }),
      threshold: 3,
      setThreshold: (threshold) => set({ threshold }),
    }),
    { name: "expertgas.alarm.v1" },
  ),
);
